import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let AlarmMsg = class AlarmMsg extends VuexModule {
    messageSwitch = true;
    topping = true;
    tipsShow = false;
    alertList = [];
    async getMessageSwitch(val) {
        try {
            return this.updateMessageSwitch(val);
        }
        catch (e) {
            throw e;
        }
    }
    async getTopping(val) {
        try {
            return this.updateTopping(val);
        }
        catch (e) {
            throw e;
        }
    }
    async getTipsShow(val) {
        try {
            return this.updateTipsShow(val);
        }
        catch (e) {
            throw e;
        }
    }
    updateAlertList(val) {
        this.alertList = [];
        this.alertList = [...val];
    }
    updateMessageSwitch(val) {
        this.messageSwitch = val;
    }
    updateTopping(val) {
        this.topping = val;
    }
    updateTipsShow(val) {
        this.tipsShow = val;
    }
};
__decorate([
    Action({ rawError: true })
], AlarmMsg.prototype, "getMessageSwitch", null);
__decorate([
    Action({ rawError: true })
], AlarmMsg.prototype, "getTopping", null);
__decorate([
    Action({ rawError: true })
], AlarmMsg.prototype, "getTipsShow", null);
__decorate([
    Mutation
], AlarmMsg.prototype, "updateAlertList", null);
__decorate([
    Mutation
], AlarmMsg.prototype, "updateMessageSwitch", null);
__decorate([
    Mutation
], AlarmMsg.prototype, "updateTopping", null);
__decorate([
    Mutation
], AlarmMsg.prototype, "updateTipsShow", null);
AlarmMsg = __decorate([
    Module({
        dynamic: true,
        store,
        name: 'senseXplorer/alarmMsg'
    })
], AlarmMsg);
export const AlarmMsgModule = getModule(AlarmMsg);
